import { render } from "./DetallePresupuesto.vue?vue&type=template&id=3c84f3d0&scoped=true"
import script from "./DetallePresupuesto.vue?vue&type=script&lang=js"
export * from "./DetallePresupuesto.vue?vue&type=script&lang=js"

import "./DetallePresupuesto.vue?vue&type=style&index=0&id=3c84f3d0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c84f3d0"

export default script